import flagKeys from '@/constants/flagKeys';
import { app } from '@/main';
import { EBusinessRewardsStatus, IBusinessType } from '@/models/business';
import { Group } from '@/router/group.model';

export const getIsRewardActivated = (group?: Group) => {
  const flags = app.$store.getters['flags/getFlags'] || [];
  const business = app.$store.getters['business/getBusinessInfo'].business;

  const rewardStatus = app.$store.getters['business/getRewardStatus'];

  if (!rewardStatus) return false;

  const currentGroup = group || app.$route.meta.$group;

  if (
    !flags.includes(flagKeys.loyaltyProgramDeactivation) ||
    (business.type === IBusinessType.INSTORE &&
      currentGroup &&
      currentGroup.id !== 'loyalty-program')
  )
    return true;

  return rewardStatus.operationStatus === EBusinessRewardsStatus.ACTIVE;
};

export const isFeatureAllowsNotHaveReward = () => {
  const business = app.$store.getters['business/getBusinessInfo'].business;

  if (!business) return false;

  return (
    app.$route.path.includes('/marketing-center/offer-free-coins') &&
    (business.type === IBusinessType.ONLINE ||
      business.type === IBusinessType.BOTH) &&
    business.country === 'United States'
  );
};
